module.exports = __webpack_public_path__ + "static/media/relevance_filter.0804447c.svg";